import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-tile-count-config',
  templateUrl: './tile-count-config.component.html',
  styleUrls: ['./tile-count-config.component.css']
})
export class TileCountConfigComponent implements OnInit, OnDestroy {

  newDescription: any;
  displayed = true;
  moduleName: string;
  description: string;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;
  addUpdate: string[] = ['Add', 'Update'];
  editValue: any;
  sequenceNumber: any;
  managementValue: any;
  hideAttachment: boolean;
  attachment = [];
  attachMsg: string;
  changedName: any;
  submit1: boolean;
  submit2: boolean;

  private fieldName: any;
  fieldValues: any;
  fieldValueSelected: any;
  private fieldValueName: any;

  fieldloader: boolean;
  addloader: boolean;
  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;
  displayData: any;
  isError = false;
  errorMessage: string;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  clientId: number;
  clients: any;
  fields = [];
  fieldSelected: number;
  clientSelected: number;
  private baseFlag: any;
  private adminAuth: Subscription;
  selectField: any;

  private notifier: NotifierService;
  offset: number;
  hiddenRadio: boolean;
  hiddenRadio1: boolean;
  hideDescName: boolean;
  dataLoaded:boolean;
  sequence: boolean;
  management: boolean;
  file: boolean;
  showSearch = false;
  isLoading = false;
  funSelected: any;
  func: any;
  funName: string;
  query: string;

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // // console.log(item);
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
          }
          break;
        case 'delete':
          // // console.log('deleted');
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
          }
          break;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.fieldloader = true;
    this.addloader = true;
    this.paginationType = 'next';
    this.hiddenRadio = false;
    this.newDescription = '';
    this.editValue = '';
    this.displayData = {
      pageName: 'maintain Configuration',
      openModalButton: 'Add Configuration',
      searchModalButton: 'Search',
      breadcrumb: 'Configuration',
      folderName: 'All Configuration',
      tabName: 'Configuration'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'funcDescription', name: 'Function Description', field: 'funcDescription', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'funcionalityName', name: 'Funcionality Name', field: 'funcionalityName', sortable: true, filterable: true
      },
      {
        id: 'clientName', name: 'Client Name', field: 'client_name', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }

    this._rest.getClient().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.respObject.clients.unshift({id: 0, name: 'Select Client'});
        this.clients = this.respObject.clients;
        this.clientSelected = 0;
      } else {

      }
    }, function (err) {

    });
  }

  onPageLoad() {
    this._rest.getAdditionalFuncTicketTypeWise(this.clientId,1).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.hiddenRadio = false;
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Field Value'});
        this.fieldValues = this.respObject.details;
        this.selectField = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this.getTableData();
  }

  openModal(content) {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.moduleName = '';
      this.description = '';
      this.sequenceNumber = '';
      this.attachMsg = '';
      this.attachment = [];
      this.newDescription = '';
      this.managementValue = '';
      this.changedName = '';
      this.fieldSelected = 0;
      this.clientSelected = 0;
      this.hiddenRadio = false;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }

  }


  getDetails() {
    for (let i = 0; i < this.func.length; i++) {
      if (this.func[i].funcDescription === this.funSelected) {
        this.funName = this.func[i].funcionalityName;
      }
    }
  }
  search() {
    const data1 = [];
    for (let i = 0; i < this.func.length; i++) {
      if (this.func[i].funcDescription === this.funSelected) {
        data1.push(this.func[i]);
      }
    }
    this.page_no = 1;
    this.messageService.setTotalData(data1.length);
    this.messageService.setGridData(data1);
  }


  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  save() {
    const data = {
      'client_id' : this.clientSelected ,
      'func_id' : this.fieldSelected ,
      'func_desc' : this.newDescription,
      'createdBy' : this.messageService.getUserId(),
      'sequence': this.sequenceNumber,
      'managementValue': this.managementValue,
      'image': this.changedName
    };
    // console.log('data=======' + JSON.stringify(data));
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertTicketFunc(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          this.nextOffset = 0;
          this.page_no = 0;
          this.getTableData();
          this.editValue = '';
          this.selectField = 0;
          this.fieldSelected = 0;
          this.clientSelected = 0;
          this.fieldloader = true;
          this.addloader = true;
          this.notifier.notify('success', 'Ticket configuration add successfully');
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
    this.sequenceNumber = '';
    this.attachMsg = '';
    this.attachment = [];
    this.newDescription = '';
    this.managementValue = '';
    this.changedName = '';

  }


  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

  }

  submitUpdate() {
    const data = {
      'client_id' : this.clientSelected,
      'func_id' : this.fieldSelected,
      'func_desc' : this.editValue,
      'func_desc_id' : this.selectField,
      'sequence': this.sequenceNumber,
      'managementValue': this.managementValue,
      'image': this.changedName
    };
    // console.log('data=======' + JSON.stringify(data));
    if (!this.messageService.isBlankField(data)) {
      this._rest.updateTicketFunc(data).subscribe((res) => {
        // // console.log(this.managementValue);
        this.respObject = res;
        if (this.respObject.success) {
          this.editValue = '';
          this.selectField = 0;
          this.fieldSelected = 0;
          this.clientSelected = 0;
          // this.hiddenRadio = false;
          this.fieldloader = true;
          this.isError = false;
          this.notifier.notify('success', 'Configuration update successfully');
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }

    this.sequenceNumber = '';
    this.attachMsg = '';
    this.attachment = [];
    this.newDescription = '';
    this.managementValue = '';
    this.changedName = '';
  }

  adddescription() {
    this.addloader = false;
    this.fieldloader = true;
    this.hideDescName = true;
    this.attachMsg = '';
    this.attachment = [];
    this.sequenceNumber = '';

  }
  changedescription() {
    this.fieldloader = false;
    this.addloader = true;
    this.attachMsg = '';
    this.attachment = [];
    this.changedName = '';
    this.sequenceNumber = '';
  }

  valueFunc(temp) {
    this.editValue = this.fieldValues[temp].name;
    this.sequenceNumber = this.fieldValues[temp].seq;
    this.managementValue = this.fieldValues[temp].isManagerialview;
    // this.selectField
    this._rest.getCountQuery(this.clientId, 1).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.hiddenRadio = true;
        this.isError = false;
        this.query = this.respObject.details[0].query_str;
        this.selectField = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onButtonChange(value) {
    // console.log(value);
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getTicketFunc(offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  executeResponse(respObject, offset, paginationType) {
    if (respObject.success) {
      this.dataLoaded=true;
      if (offset === 0) {
        this.totalData = respObject.details.totalData[0].count;
        this.totalPage = respObject.details.totalPage;
        if (this.totalPage === 0) {
          this.totalPage = 1;
        }
      }
      if (!this.isEmpty(respObject.details.dataObj)) {
        const data = respObject.details.dataObj;
        this.nextOffset = respObject.details.nextOffset;
        this.offset = respObject.details.nextOffset;
        this.previousOffset = respObject.details.previousOffset;
        this.messageService.setTotalData(this.totalData);
        this.messageService.setGridData(data);
        // ----------------------------------------------
        if (offset !== 0) {
          const totalCount = this.totalData;
          const divRes = totalCount / this.pageSize;
          const remainder = totalCount % this.pageSize;
          if (remainder === 0) {
            this.totalPage = parseInt(String(divRes), 10);
          } else {
            this.totalPage = parseInt(String(divRes), 10) + 1;
          }
        }
        // ------------------------------------------------
        if (paginationType === 'next') {
          this.page_no = this.page_no + 1;
        } else if (paginationType === 'prev') {
          this.page_no = this.page_no - 1;
        } else if (paginationType === '' && this.page_no === 0) {
          this.page_no = this.page_no + 1;
        }
        if (this.totalData <= this.pageSize * this.page_no) {
          this.nextOffset = 0;
        }
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
        this.nextOffset = 0;
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
        this.previousOffset = 0;
      } else if (paginationType === '' && this.page_no === 0) {
        this.page_no = this.page_no + 1;
      }
    } else {
      this.notifier.notify('error', respObject.errorMessage);
    }
  }


  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }

}
